import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthenticatedComponent } from '../auth/keycloak';
import { getUserPrivateProfile } from '../service/social';

export const LoginRedirectPage: AuthenticatedComponent = ({ keycloak }) => {
    const navigate = useNavigate();
    const sourcePathStorageKey = 'streamsix_keycloak_redir_source';

    useEffect(() => {
        const setup = async () => {
            const prevPath = localStorage.getItem(sourcePathStorageKey) || '/';
            try {
                const profile = await getUserPrivateProfile(keycloak.subject, keycloak.token);

                if (!!profile?.has_account) {
                    //this is just some hackiness needed in non-prod envs due to react strict mode
                    if (process.env.NODE_ENV === 'production') {
                        localStorage.removeItem(sourcePathStorageKey);
                    }

                    navigate(prevPath, { replace: true });
                    return;
                } else {
                    navigate('/setup/profile', { replace: true });
                    return;
                }
            } catch {
                if (process.env.NODE_ENV === 'production') {
                    localStorage.removeItem(sourcePathStorageKey);
                }

                navigate(prevPath, { replace: true });
            }
        };

        setup();
    }, []);

    return <></>;
};
